module.exports = __webpack_public_path__ + "macbook-benchmarking.7bf688a3269784df0fa2f87498e62af5.png";